export default {
  currentPeriod: {},
  referencePeriod: {},
  allConfigurationPeriods: [],
  configuration: {},
  clientsMetrics: {
    current: {},
    reference: {},
  },
  periodMigrations: null,
  isFetchingAnalyticsConfiguration: false,
  isFetchingAllAnalyticPeriods: false,
  rfvAnalyticConfigurations: [],
  loadingAnalyticConfigurations: false,
}
